import { defineStore } from 'pinia'
import { ref } from 'vue'

// Client-only state for the notifications drawer. Notifications data itself
// lives in the TanStack Query cache (see useNotificationsQuery).
export const useNotificationsStore = defineStore('notifications', () => {
  const drawerOpen = ref(false)

  const openDrawer = () => {
    drawerOpen.value = true
  }

  const closeDrawer = () => {
    drawerOpen.value = false
  }

  return { drawerOpen, openDrawer, closeDrawer }
})
